<template>
  <footer class="footer">
    <div class="px-5" style="padding-bottom: 10px">
      <div class="row" style="padding-bottom: 10px">
        <div class="col-md-3">
          <img src="../assets/logoBlanco.png" class="img-fluid">
        </div>

        <div class="col-md-3 footer-vertical">
          <h5>DIRECCI&Oacute;N</h5>
          <p>Av. Hispanoaméricana #100, Thomén, Código postal No. 51000 Santiago, República Dominicana</p>
        </div>
        <div class="col-md-3 footer-vertical offset-1">
          <h5>CONTACTO</h5>
          <p>(809) 724-0266; Ext. 417–370 <span><br></span> Correo: observatorioct@uapa.edu.do    </p>
        </div>
      </div>
    </div>
    <div class="copyright text-right">
      <div class="p-3 text-muted">
        <!-- © 2018 creativeLabs. Designed and built by <a href="https://twitter.com/lukaszholeczek">@lukaszholeczek</a>.
         Code licensed under an MIT-style License.-->
        © 2018 Vicerrectoría de Investigación y Postgrado.UAPA
      </div>
    </div>
  </footer>
</template>
<script>
export default {
  name: 'c-footer'
}
</script>



// WEBPACK FOOTER //
// src/components/Footer.vue